import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "2:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-200-1-mode.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
  "2:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-200-2-modes.mp4`,
          controls: false,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "1% 13%",
      },
    },
  },
};

export default components;
